import React from 'react';
import { Redirect } from 'react-router-dom';
import { Container, Dimmer, Form, Loader } from 'semantic-ui-react';
import { ClientModel } from '../../../entities/client.model';
import { ImageModel } from '../../../entities/image.model';
import MyForm from './form';
import MyFormState from './MyFormState';
import './entity-form.scss';

interface FormProps {
    match: any,
    history: any
}

class ClientForm extends MyForm<FormProps, MyFormState> {
    entity = 'client'

    constructor(props: any) {
        super(props);
        this.state = {
            model: new ClientModel,
            successMsg: "",
            errorMsg: "",
            loading: true,
            editing: false,
            editingSlug: false,
            slugValid: true,
            imageObj: ImageModel.empty(),
            imageObjs: { lg: ImageModel.empty(), sm: ImageModel.empty(), xs: ImageModel.empty(),
                image1: ImageModel.empty(), image2: ImageModel.empty(), image3: ImageModel.empty(),
                image4: ImageModel.empty(), image5: ImageModel.empty(), image6: ImageModel.empty()
            },
            redirect: "",
        }
    }

    validate(): boolean {
        this.setState({ successMsg: "" });
        
        if (this.state.model.id !== undefined) {
            const activeUnchanged = this.state.model.active === this.originalModel.active;
            const superUserUnchanged = this.state.model.superUser === this.originalModel.superUser;
            if (activeUnchanged && superUserUnchanged) {
                this.setState({ errorMsg: "Өөрчлөлт байхгүй байна"});
                return false;
            }
        }
        this.setState({ errorMsg: "" });
        return true;
    }

    async save() {
        if (!this.validate()) {
            window.scrollTo(0, 0);
            return;
        }

        var token = this.getAdminToken()
        this.setState({ loading: true });

        // POST to API
        let payload = {
            clientId: this.state.model.id,
            active: this.state.model.active ? 1 : 0,
            superUser: this.state.model.superUser
        }

        fetch(process.env.REACT_APP_API_URL + 'mongol/client', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Authorization': token,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        })
        .then(res => {
            if (res.status === 200) {
                this.originalModel.active = this.state.model.active;
                this.originalModel.superUser = this.state.model.superUser;
                this.setState({ loading: false, successMsg: "Амжилттай хадгаллаа." })
            }
            else if (res.status === 401) {
                this.setState({ redirect: this.loginUrl})
            }
            else {
                res.json().then(res => {
                    if (res.error) {
                        this.setState({ loading: false, errorMsg: res.error })
                        this.recordSaved = false;
                        window.scrollTo(0,0);
                        return;
                    }
                    
                })
            }
        })
        .catch(err => {
            this.setState({ loading: false });
            console.error(err);
        });
    }

    onSuperUserChange = (e: any) => {
        const isChecked = e.target.checked;
        const superUserValue = isChecked ? 1 : 0;
        this.setState(prevState => ({
            model: { ...prevState.model, superUser: superUserValue }
        }));
    }

    render() {
        if (this.state.redirect) {
            return <Redirect to={this.state.redirect}/>
        }
        return (
            <Container className="admin-entity-form">
                <Dimmer active={this.state.loading} inverted>
                    <Loader size='medium'></Loader>
                </Dimmer>
                <Form widths='equal' stackable>
                    <Form.Group>
                        { this.state.successMsg ? <div className="success-msg">{this.state.successMsg}</div> : null }
                        { this.state.errorMsg ? <div className="error-msg">{this.state.errorMsg}</div> : null }
                    </Form.Group>
                    <Form.Group widths='equal' className="admin-entity-form__field-row">
                        <div className="admin-entity-form__label">Овог</div>
                        <div className="admin-entity-form__value">{this.state.model.parentName}</div>
                    </Form.Group>
                    <Form.Group widths='equal' className="admin-entity-form__field-row">
                        <div className="admin-entity-form__label">Нэр</div>
                        <div className="admin-entity-form__value">{this.state.model.ownName}</div>
                    </Form.Group>
                    <Form.Group widths='equal' className="admin-entity-form__field-row">
                        <div className="admin-entity-form__label">Имэйл</div>
                        <div className="admin-entity-form__value">{this.state.model.email}</div>
                    </Form.Group>
                    <Form.Group widths='equal' className="admin-entity-form__field-row">
                        <div className="admin-entity-form__label">Утасны дугаар</div>
                        <div className="admin-entity-form__value">{this.state.model.phone}</div>
                    </Form.Group>
                    <Form.Group className="admin-entity-form__checkbox-row">
                        <input type="checkbox" id="company-active" onChange={this.onActiveChange} checked={this.state.model.active} />
                        &nbsp;
                        <label htmlFor="company-active">{ this.state.model.active ? "Идэвхитэй" : "Идэвхигүй" }</label>
                    </Form.Group>
                    <Form.Group className="admin-entity-form__checkbox-row">
                        <input
                            type="checkbox"
                            id="client-superUser"
                            onChange={(e) => this.onSuperUserChange(e)}
                            checked={this.state.model.superUser === 1}
                        />
                        &nbsp;
                        <label htmlFor="client-superUser">Дэлгүүр болон веб захиалгын эрхтэй</label>
                    </Form.Group>
                    <Form.Group className="admin-entity-form__field-row">
                        <div className="admin-entity-form__label">Хаяг:</div>
                    </Form.Group>
                    <Form.Group className="admin-entity-form__field-row">
                        <div className="admin-entity-form__label">Хот</div>
                        <div className="admin-entity-form__value">{this.state.model.town}</div>
                    </Form.Group>
                    <Form.Group className="admin-entity-form__field-row">
                        <div className="admin-entity-form__label">Дүүрэг</div>
                        <div className="admin-entity-form__value">{this.state.model.district}</div>
                    </Form.Group>
                    <Form.Group className="admin-entity-form__field-row">
                        <div className="admin-entity-form__label">Хороо</div>
                        <div className="admin-entity-form__value">{this.state.model.unit}</div>
                    </Form.Group>
                    <Form.Group className="admin-entity-form__field-row">
                        <div className="admin-entity-form__label">Дэлгэрэнгүй</div>
                        <div className="admin-entity-form__value">{this.state.model.street}</div>
                    </Form.Group>
                    {/* <Form.Group>
                        <MyLabel>Зипкод</MyLabel>
                        <div>{this.state.model.town}</div>
                    </Form.Group> */}

                    <br/>
                    <Form.Button disabled={this.state.loading} onClick={() => this.save()}>Хадгалах</Form.Button>
                </Form>
            </Container>
        );
    }
}

export default ClientForm;